import { ResolveFn } from '@angular/router';
import { UserProfile } from '../models';
import { inject } from '@angular/core';
import { UserProfileFacade } from '@cpd-app/state/user-profile';
import { filter } from 'rxjs';

export const userResolver: ResolveFn<UserProfile> = () => {
  return inject(UserProfileFacade).userProfileLoadIfEmpty$.pipe(
    filter((userProfile) => !!userProfile),
  );
};
